import React from 'react'
import {useDispatch} from 'react-redux'
import * as collectionActions from '../../../store/collection/collectionActions'
import { locale } from '../../../ui/locale';
import { FormControl, FormControlLabel, Radio } from '@mui/material';

export default function DroppedFilter (p: any) {
    const dispatch = useDispatch();

    return (
        <FormControl sx={{paddingLeft: 2}}>
                <FormControlLabel 
                    sx={{
                        fontSize: '.875rem',
                        // fontWeight: 600,    
                        color: !p.cll.viewProps.viewOnlyDropped ? 'text.primary' : 'action.active',
                        '&:hover': {color: 'text.primary'}
                    }}
                    disableTypography
                    checked={!p.cll.viewProps.viewOnlyDropped} 
                    control={<Radio size='small'  sx={{padding: '4px'}} />} 
                    label={locale('filters.dropped.allItems')} 
                    onClick={event =>  dispatch(collectionActions
                        .changeViewProps({viewOnlyDropped: false}) )}
                />
                <FormControlLabel 
                    sx={{
                        fontSize: '.875rem',
                        // fontWeight: 600,    
                        color: p.cll.viewProps.viewOnlyDropped ? 'text.primary' : 'action.active',
                        '&:hover': {color: 'text.primary'}
                    }}
                    disableTypography
                    checked={p.cll.viewProps.viewOnlyDropped} 
                    control={<Radio size='small'  sx={{padding: '4px'}} />} 
                    label={locale('filters.dropped.droppedItems')} 
                    onClick={event =>  dispatch(collectionActions
                        .changeViewProps({viewOnlyDropped: true}) )}
                />
        </FormControl>        

    )
}